<template>
    <div :style="getStyle(data?.style)">
      <qrcode-vue
        :value="data?.props?.url || ''"
        :size="data?.props?.size || 128"  
      />
    </div>
  </template>
  
  <script>
  import QrcodeVue from 'qrcode.vue';
  
  export default {
    name: 'QrCodeBlock',
    components: {
      QrcodeVue,
    },
    props: {
      data: Object,
    },
    methods: {
      getStyle(style) {
        // Fallback für Padding und Textausrichtung
        const padding = style?.padding || { top: 0, right: 0, bottom: 0, left: 0 };
        const textAlign = style?.textAlign || 'left';
        
        return {
          textAlign: textAlign,
          padding: `${padding.top}px ${padding.right}px ${padding.bottom}px ${padding.left}px`,
        };
      },
    },
  };
  </script>
  